import React from "react";
import { BrowserRouter, Route, Routes } from "react-router-dom";
import AnaSayfa from "../Pages/AnaSayfa";
import Contact from "../Pages/Contact";
import Ilanlar from "../Pages/Ilanlar";
import IlanDetay from "../Pages/IlanDetay";

const AppRouter = () => {
  return (
    <BrowserRouter>
      <Routes>
        {/* <Route path="/" element={<div>Bakım var!</div>} exact="true"></Route> */}
        <Route path="*" element={<RedirectToHome />} />

        <Route path="/" element={<AnaSayfa />} exact="true"></Route>
        <Route path="/iletisim" element={<Contact />} exact="true"></Route>
        <Route path="/ilanlar" element={<Ilanlar />} exact="true"></Route>
        <Route path="/ilan-detay" element={<IlanDetay />} exact="true"></Route>
      </Routes>
    </BrowserRouter>
  );

  function RedirectToHome() {
    window.location.replace(window.location.origin);
    return null;
  }
};

export default AppRouter;
